import React from 'react';
import { AlertModal, Text } from '@cashfree-intl/coherent';

const PaypalActivationFailed = ({ closeModal, data }: {
  closeModal: () => void,
  data: any,
}) => (
  <AlertModal
    type="danger"
    title="Failed to activate PayPal"
    onClose={closeModal}
    eventNameOnClose="Failed_To_Activate_Paypal_Close"
  >
    {data?.length === 1 && <Text color="bodyLight">{data[0]}</Text>}
    {data?.length > 1 && (
      <ul className="list-style-disc px-4">
        {data.map((text, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <li key={index}>
            <Text color="bodyLight">{text}</Text>
          </li>
        ))}
      </ul>
    )}
  </AlertModal>
);

export default PaypalActivationFailed;
